import { useState } from 'react';
import { CopyIcon } from '@rsos/assets/icons';
import { CopyButton, CopyButtonText } from './CopyFieldButton.styles';

/**
 * Ellington friendly CopyFieldButton component which is shown on hover of
 * each Ellington generated field values.
 * @param {Object} props
 * @param {Function} props.triggerCopy - Function to trigger copy
 */
const CopyFieldButton = ({ triggerCopy, hoverable = true }) => {
  const [isCopied, setIsCopied] = useState(false);

  const handleClick = () => {
    triggerCopy(() => {
      setIsCopied(true);
      window.setTimeout(() => {
        setIsCopied(false);
      }, 3000);
    });
  };

  return (
    <CopyButton
      copied={isCopied}
      onClick={handleClick}
      hoverable={hoverable}
      // CopyButton is display: none by default, the className is used in
      // CustomRenderer.styles to toggle visibility on hover.
      className="ellington-copy-field-button"
    >
      <CopyIcon height={12} width={12} />
      <CopyButtonText>{isCopied ? 'COPIED' : 'COPY'}</CopyButtonText>
    </CopyButton>
  );
};

export default CopyFieldButton;
